var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDirectMessaging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3737 15.8501C33.3737 23.9505 26.1496 30.4519 17.3121 30.4519C16.1681 30.4519 15.0545 30.3395 13.9766 30.1325",
    stroke: "url(#paint0_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67287 27.5126C3.78417 24.8535 1.25 20.6383 1.25 15.8501",
    stroke: "url(#paint1_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67294 27.5125C7.67116 29.0365 7.67473 31.0924 7.67473 33.25",
    stroke: "url(#paint2_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.85C1.25 7.74961 8.47417 1.25 17.3116 1.25C26.1491 1.25 33.3733 7.7514 33.3733 15.8518",
    stroke: "url(#paint3_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9732 30.1255L7.6735 33.2486",
    stroke: "url(#paint4_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6266 15.9074C17.8009 16.0816 17.8009 16.3641 17.6266 16.5384C17.4524 16.7126 17.1699 16.7126 16.9957 16.5384C16.8214 16.3641 16.8214 16.0816 16.9957 15.9074C17.1699 15.7332 17.4524 15.7332 17.6266 15.9074",
    stroke: "url(#paint5_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7657 15.9074C24.9399 16.0816 24.9399 16.3641 24.7657 16.5384C24.5915 16.7126 24.309 16.7126 24.1347 16.5384C23.9605 16.3641 23.9605 16.0816 24.1347 15.9074C24.309 15.7332 24.5915 15.7332 24.7657 15.9074",
    stroke: "url(#paint6_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4891 15.9074C10.6633 16.0816 10.6633 16.3641 10.4891 16.5384C10.3148 16.7126 10.0324 16.7126 9.85812 16.5384C9.68389 16.3641 9.68389 16.0816 9.85812 15.9074C10.0324 15.7332 10.3148 15.7332 10.4891 15.9074",
    stroke: "url(#paint7_linear_1_271)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_271",
    x1: 13.9766,
    y1: 23.151,
    x2: 33.3737,
    y2: 23.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_271",
    x1: 1.25,
    y1: 21.6814,
    x2: 7.67287,
    y2: 21.6814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_271",
    x1: 6.78127,
    y1: 30.3812,
    x2: 8.5659,
    y2: 30.3812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_271",
    x1: 1.25,
    y1: 8.55091,
    x2: 33.3733,
    y2: 8.55091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_271",
    x1: 7.6735,
    y1: 31.687,
    x2: 13.9732,
    y2: 31.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_271",
    x1: 16.4188,
    y1: 16.2229,
    x2: 18.2035,
    y2: 16.2229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_271",
    x1: 23.5579,
    y1: 16.2229,
    x2: 25.3425,
    y2: 16.2229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_271",
    x1: 9.28129,
    y1: 16.2229,
    x2: 11.0659,
    y2: 16.2229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirectMessaging);
export default __webpack_public_path__ + "static/media/icon-direct-messaging.3003b2af15e1b7a6322a3993da9e1f50.svg";
export { ForwardRef as ReactComponent };